import React from 'react';
import PropTypes from 'prop-types';
import Searchbar from '../../Components/Searchbar';

const AudioSearch = ({ onSearch, searchTerm, onSearchTermChange }) => {
  return (
    <Searchbar
      searchTerm={searchTerm}
      onSearchTermChange={onSearchTermChange}
      onSearch={onSearch}
      placeholder="Search"
      alwaysShowIcon={true}
      customStyles={{ 
        padding: '0.8vh 1.6vh', 
        height: '4vh', 
        borderRadius: '1.6vh' 
      }}
      inputStyles={{ padding: '0.4vh 1.6vh', fontSize: '1.6vh' }}
      iconStyles={{ filter: 'brightness(0) invert(1)' }}
    />
  );
};

AudioSearch.propTypes = {
  onSearch: PropTypes.func.isRequired,
  searchTerm: PropTypes.string.isRequired,
  onSearchTermChange: PropTypes.func.isRequired
};

export default AudioSearch;